import React from "react";
import { IconProps } from "../../types/component";
import useChakraColor from "../../hooks/useChakraColor";

export const Calendar: React.FC<IconProps> = ({
  size = 12,
  color = "#E67D4F",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.625 0.75C6.03921 0.75 6.375 1.08579 6.375 1.5V2.25H11.625V1.5C11.625 1.08579 11.9608 0.75 12.375 0.75C12.7892 0.75 13.125 1.08579 13.125 1.5V2.26852C15.02 2.45666 16.5 4.05549 16.5 6V12.75C16.5 14.8211 14.8211 16.5 12.75 16.5H5.25C3.17893 16.5 1.5 14.8211 1.5 12.75V6C1.5 4.05549 2.98 2.45666 4.875 2.26852V1.5C4.875 1.08579 5.21079 0.75 5.625 0.75ZM3.12803 5.25H14.872C14.5631 4.37611 13.7297 3.75 12.75 3.75H5.25C4.27034 3.75 3.43691 4.37611 3.12803 5.25ZM15 6.75H3V12.75C3 13.9926 4.00736 15 5.25 15H12.75C13.9926 15 15 13.9926 15 12.75V6.75ZM4.5 9C4.5 8.58579 4.83579 8.25 5.25 8.25H12.75C13.1642 8.25 13.5 8.58579 13.5 9C13.5 9.41421 13.1642 9.75 12.75 9.75H5.25C4.83579 9.75 4.5 9.41421 4.5 9Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const List: React.FC<IconProps> = ({ size = 10, color = "#E67D4F" }) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9999 6.99927H5.09082H13.9999Z"
        fill={iconColor}
      />
      <path
        d="M13.9999 6.99927H5.09082"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9999 12.5996H5.09082H13.9999Z"
        fill={iconColor}
      />
      <path
        d="M13.9999 12.5996H5.09082"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9999 1.39893H5.09082H13.9999Z"
        fill={iconColor}
      />
      <path
        d="M13.9999 1.39893H5.09082"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.27125 2.8C1.90762 2.8 2.54398 2.1 2.54398 1.4C2.54398 0.7 1.90762 0 1.27125 0C0.634888 0 0 0.7 0 1.4C0 2.1 0.634888 2.8 1.27125 2.8ZM1.27125 8.4C1.90762 8.4 2.54398 7.7 2.54398 7C2.54398 6.3 1.90762 5.6 1.27125 5.6C0.634888 5.6 0 6.3 0 7C0 7.7 0.634888 8.4 1.27125 8.4ZM1.27125 14C1.90762 14 2.54398 13.3 2.54398 12.6C2.54398 11.9 1.90762 11.2 1.27125 11.2C0.634888 11.2 0 11.9 0 12.6C0 13.3 0.634888 14 1.27125 14Z"
        fill={iconColor}
      />
    </svg>
  );
};

export const MarillacCoin: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6565_5715)">
      <path
        d="M11.0002 22.0004C16.7378 22.0004 21.3891 17.3492 21.3891 11.6115C21.3891 5.87392 16.7378 1.22266 11.0002 1.22266C5.26259 1.22266 0.611328 5.87392 0.611328 11.6115C0.611328 17.3492 5.26259 22.0004 11.0002 22.0004Z"
        fill="#F4900C"
      />
      <path
        d="M11.0002 20.7778C16.7378 20.7778 21.3891 16.1265 21.3891 10.3889C21.3891 4.65126 16.7378 0 11.0002 0C5.26259 0 0.611328 4.65126 0.611328 10.3889C0.611328 16.1265 5.26259 20.7778 11.0002 20.7778Z"
        fill="#FFCC4D"
      />
      <path
        d="M10.9999 18.9441C15.725 18.9441 19.5554 15.1137 19.5554 10.3886C19.5554 5.66346 15.725 1.83301 10.9999 1.83301C6.27479 1.83301 2.44434 5.66346 2.44434 10.3886C2.44434 15.1137 6.27479 18.9441 10.9999 18.9441Z"
        fill="#FFAC33"
      />
      <path
        d="M7.10372 15.6855C6.74911 15.6855 6.47429 15.5841 6.27926 15.3813C6.09309 15.1784 6 14.8926 6 14.5237V6.84737C6 6.46932 6.10195 6.18347 6.30585 5.98983C6.50975 5.78698 6.79787 5.68555 7.17021 5.68555C7.4805 5.68555 7.72429 5.75009 7.9016 5.87918C8.08777 5.99906 8.25621 6.20191 8.40691 6.48776L11.266 11.8266H10.8005L13.6463 6.48776C13.8059 6.20191 13.9743 5.99906 14.1516 5.87918C14.3378 5.75009 14.586 5.68555 14.8963 5.68555C15.2509 5.68555 15.5213 5.78698 15.7074 5.98983C15.9025 6.18347 16 6.46932 16 6.84737V14.5237C16 14.8926 15.9069 15.1784 15.7207 15.3813C15.5346 15.5841 15.2598 15.6855 14.8963 15.6855C14.5417 15.6855 14.2668 15.5841 14.0718 15.3813C13.8856 15.1784 13.7926 14.8926 13.7926 14.5237V9.76577H14.0718L11.9309 13.6385C11.8067 13.8414 11.6738 13.9935 11.5319 14.095C11.3989 14.1964 11.2172 14.2471 10.9867 14.2471C10.7651 14.2471 10.5833 14.1964 10.4415 14.095C10.2996 13.9935 10.1711 13.8414 10.0559 13.6385L7.9016 9.75194H8.20745V14.5237C8.20745 14.8926 8.11436 15.1784 7.92819 15.3813C7.74202 15.5841 7.4672 15.6855 7.10372 15.6855Z"
        fill="#F4900C"
      />
      <path
        d="M7.10372 14.6855C6.74911 14.6855 6.47429 14.5943 6.27926 14.4117C6.09309 14.2291 6 13.9719 6 13.6399V6.73119C6 6.39094 6.10195 6.13368 6.30585 5.95941C6.50975 5.77683 6.79787 5.68555 7.17021 5.68555C7.4805 5.68555 7.72429 5.74364 7.9016 5.85982C8.08777 5.9677 8.25621 6.15028 8.40691 6.40754L11.266 11.2125H10.8005L13.6463 6.40754C13.8059 6.15028 13.9743 5.9677 14.1516 5.85982C14.3378 5.74364 14.586 5.68555 14.8963 5.68555C15.2509 5.68555 15.5213 5.77683 15.7074 5.95941C15.9025 6.13368 16 6.39094 16 6.73119V13.6399C16 13.9719 15.9069 14.2291 15.7207 14.4117C15.5346 14.5943 15.2598 14.6855 14.8963 14.6855C14.5417 14.6855 14.2668 14.5943 14.0718 14.4117C13.8856 14.2291 13.7926 13.9719 13.7926 13.6399V9.35775H14.0718L11.9309 12.8432C11.8067 13.0258 11.6738 13.1627 11.5319 13.254C11.3989 13.3453 11.2172 13.3909 10.9867 13.3909C10.7651 13.3909 10.5833 13.3453 10.4415 13.254C10.2996 13.1627 10.1711 13.0258 10.0559 12.8432L7.9016 9.3453H8.20745V13.6399C8.20745 13.9719 8.11436 14.2291 7.92819 14.4117C7.74202 14.5943 7.4672 14.6855 7.10372 14.6855Z"
        fill="#FFD983"
      />
    </g>
    <defs>
      <clipPath id="clip0_6565_5715">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Profile: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6035_12883)">
      <path
        d="M7.5 6.38477C6.67533 6.38477 5.969 6.09077 5.381 5.50277C4.793 4.91477 4.49933 4.20877 4.5 3.38477C4.50067 2.56077 4.79433 1.8541 5.381 1.26477C5.96767 0.675437 6.674 0.382437 7.5 0.38577C8.326 0.389104 9.03233 0.682437 9.619 1.26577C10.2057 1.8491 10.4993 2.55577 10.5 3.38577C10.5007 4.21577 10.207 4.92177 9.619 5.50377C9.031 6.08577 8.32467 6.37877 7.5 6.38477ZM0.5 13.6158V11.9698C0.5 11.5571 0.62 11.1711 0.86 10.8118C1.10067 10.4518 1.424 10.1724 1.83 9.97377C2.774 9.5211 3.71867 9.18177 4.664 8.95577C5.60867 8.7291 6.554 8.61577 7.5 8.61577C8.446 8.61577 9.39167 8.7291 10.337 8.95577C11.2823 9.18244 12.2263 9.52177 13.169 9.97377C13.5757 10.1724 13.899 10.4518 14.139 10.8118C14.3797 11.1711 14.5 11.5571 14.5 11.9698V13.6158H0.5ZM1.5 12.6158H13.5V11.9698C13.5 11.7484 13.4283 11.5401 13.285 11.3448C13.1423 11.1501 12.9447 10.9854 12.692 10.8508C11.8693 10.4521 11.0207 10.1468 10.146 9.93477C9.27133 9.72277 8.38933 9.61644 7.5 9.61577C6.61067 9.6151 5.72867 9.7211 4.854 9.93377C3.97933 10.1464 3.13067 10.4518 2.308 10.8498C2.05467 10.9844 1.857 11.1491 1.715 11.3438C1.57167 11.5391 1.5 11.7478 1.5 11.9698V12.6158ZM7.5 5.38577C8.05 5.38577 8.521 5.18977 8.913 4.79777C9.305 4.40577 9.50067 3.93444 9.5 3.38377C9.49933 2.8331 9.30367 2.36244 8.913 1.97177C8.52233 1.5811 8.05133 1.3851 7.5 1.38377C6.94867 1.38244 6.478 1.57844 6.088 1.97177C5.698 2.3651 5.502 2.83577 5.5 3.38377C5.498 3.93177 5.694 4.40277 6.088 4.79677C6.482 5.19077 6.95267 5.38644 7.5 5.38377"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_6035_12883">
        <rect width="15" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Trophy: React.FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6440_5902)">
      <path
        d="M5.12332 5H11.1233C12.2273 5 13.0003 4.896 13.0003 6V4C13.0003 2.896 12.2273 2 11.1233 2H3.12332C1.12332 2 -0.459679 4.125 0.123321 7C0.123321 7 1.91432 16.375 2.04032 16.958C2.37332 18.5 4.16432 20 6.08132 20H13.0393C14.1443 20 13.0003 18.104 13.0003 17V15C13.0003 16.104 12.2273 17 11.1233 17H7.12332C6.01932 17 5.29032 15.958 5.12332 15C4.95632 14.042 3.53932 7.667 3.53932 7.667C3.20632 5.75 4.01832 5 5.12332 5ZM30.9353 5H24.9353C23.8313 5 22.0003 4.896 22.0003 6V4C22.0003 2.896 23.8313 2 24.9353 2H32.9353C34.9353 2 36.5193 4.125 35.9353 7C35.9353 7 34.3023 16.419 34.1643 17C33.8103 18.5 32.1223 20 30.1643 20H23.0183C21.9143 20 22.0003 18.104 22.0003 17V15C22.0003 16.104 23.8313 17 24.9353 17H28.9353C30.0393 17 30.7693 15.958 30.9353 15C31.1013 14.042 32.5193 7.667 32.5193 7.667C32.8513 5.75 32.0403 5 30.9353 5ZM20.8323 22C20.8323 15.042 18.1233 22 18.1233 22C18.1233 22 15.1233 15.042 15.1233 22C15.1233 28.958 11.8323 32 11.8323 32H24.1243C24.1233 32 20.8323 28.958 20.8323 22Z"
        fill="#FFAC33"
      />
      <path
        d="M29.123 6.57747C29.123 13.3525 22.353 24.7695 18.123 24.7695C13.893 24.7695 7.12305 13.3525 7.12305 6.57747C7.12305 1.38247 8.12305 0.25847 10.123 0.25847C11.497 0.25847 16.148 0.23147 18.123 0.23147L25.123 0.23047C28.04 0.22947 29.123 0.91447 29.123 6.57747Z"
        fill="#FFD983"
      />
      <path
        d="M27 33C27 34.104 27.227 35 26.123 35H10.123C9.018 35 9 34.104 9 33V32C9 30.896 10.164 30 11.206 30H25.123C26.165 30 27 30.896 27 32V33Z"
        fill="#F4900C"
      />
      <path
        d="M29 34.625C29 35.385 29.165 36 27.748 36H8.498C7.206 36 7 35.385 7 34.625V34.375C7 33.615 7.738 33 8.498 33H27.748C28.507 33 29 33.615 29 34.375V34.625Z"
        fill="#F4900C"
      />
      <path
        d="M2.61604 32.4261L2.77615 31.9242L2.49939 31.476L3.00125 31.6361L3.44947 31.3593L3.28937 31.8612L3.56613 32.3094L3.06427 32.1493L2.61604 32.4261Z"
        fill="#E6A98E"
        fillOpacity="0.75"
      />
      <path
        d="M30.8093 29.2145L30.8616 28.6169L30.3095 28.3826L30.8939 28.2476L30.9462 27.6501L31.2552 28.1642L31.8396 28.0293L31.4461 28.482L31.755 28.9962L31.2029 28.7618L30.8093 29.2145Z"
        fill="#4597A1"
        fillOpacity="0.65"
      />
      <circle
        cx="0.26405"
        cy="27.6361"
        r="0.26405"
        fill="#E67D4F"
        fillOpacity="0.65"
      />
      <path
        d="M3.19438 29.4078L3.135 29.0011L2.78762 28.7814L3.19431 28.722L3.41397 28.3747L3.47335 28.7814L3.82074 29.001L3.41404 29.0604L3.19438 29.4078Z"
        fill="#0C727E"
        fillOpacity="0.65"
      />
      <circle
        cx="35.223"
        cy="28.3793"
        r="0.710331"
        fill="#4597A1"
        fillOpacity="0.45"
      />
      <circle
        cx="34.9255"
        cy="34.6277"
        r="0.41281"
        fill="#4597A1"
        fillOpacity="0.6"
      />
    </g>
    <defs>
      <clipPath id="clip0_6440_5902">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ExitDoor: React.FC<IconProps> = ({
  size = 16,
  color = "indicate.brightRed",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66634 2.66647H10.6663C11.02 2.66647 11.3591 2.80695 11.6091 3.057C11.8592 3.30705 11.9997 3.64618 11.9997 3.99981V13.3331M1.33301 13.3331H3.33301M3.33301 13.3331L7.83834 14.4591C7.9366 14.4836 8.03914 14.4854 8.1382 14.4644C8.23725 14.4434 8.33021 14.4 8.41002 14.3377C8.48983 14.2754 8.55439 14.1957 8.5988 14.1047C8.64322 14.0137 8.66631 13.9137 8.66634 13.8125V3.04114C8.66621 2.83859 8.61993 2.63807 8.53103 2.45608C8.44212 2.27409 8.31292 2.11475 8.15323 1.99015C7.99355 1.86555 7.80757 1.77897 7.60943 1.73698C7.41128 1.69498 7.20617 1.69869 7.00967 1.74781L4.34301 2.41447C4.05456 2.48657 3.79848 2.65302 3.61548 2.88736C3.43248 3.1217 3.33305 3.41048 3.33301 3.70781V13.3331ZM8.66634 13.3331H14.6663M6.66634 7.99981V8.00647"
        stroke={iconColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const Triangle: React.FC<IconProps> = ({ size = 12 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.79035 0.506928C5.17342 -0.169033 6.14732 -0.169033 6.53038 0.506929L11.1896 8.72865C11.5673 9.39529 11.0858 10.2217 10.3195 10.2217L1.00119 10.2217C0.234953 10.2217 -0.246602 9.39528 0.131174 8.72865L4.79035 0.506928Z"
      fill="#0C727E"
    />
  </svg>
);

export const Eye: React.FC<IconProps> = ({
  size = 16,
  color = "text.medium",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_iconCarrier">
        <path
          d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const ClosedEye: React.FC<IconProps> = ({
  size = 16,
  color = "text.medium",
}) => {
  const iconColor = useChakraColor(color);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_iconCarrier">
        <path
          d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5"
          stroke={iconColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
